import {OggettoConfig} from "../../../app/shared/_services/dynamic-crud.service";
import {CampoAggiuntivo} from "../../../app/shared/models/campo-aggiuntivo";
import {FieldViewerComponent} from "../../../app/shared/field-viewer/field-viewer.component";
import {ApiPathsService} from "../../../app/api-paths.service";

export function Prodotti() {
  var OBJ: OggettoConfig = {
    Id: "catalogo-frigo",
    RestRoute: "/prodotti",
    ListDefaultFilter: {tipo: 68, prodotto:"FRIGSP", },
    ListResponseHasData: true,
    listTitle: "Catalogo",
    HasAddList: {func:()=>true},
    Buttons: [
    ],
    ListMap: (list) => list.map(coupon => {
      return {...coupon}
    }),
    Map: (x) => {
      return {...x, prezzo: x.prezzi?.length ? x.prezzi[0].prezzo : 0}
    },
    OnSaveMap: (x) => {
      return {...x, prezzi: [{um: 64, prezzo: x.prezzo, iva: 22,}], tipo: 50}
    },
    PrintHeaders:[
      CampoAggiuntivo.InputField("Codice", "prodotto", "text", "", {modificabile: false, printable:true}),
      CampoAggiuntivo.InputField("Descrizione", "descrizioneBreve", "text", "", {modificabile: false, printable:true}),
      {nome: "Scheda Prodotto", oggetti: ["scheda"], type: 'html', func: (coupon, parent?) => coupon.id_scheda ? `https://customer.klimaitalia.it/api/file/image/${coupon.id_scheda}`: ''},
      {nome: "Immagine Prodotto", oggetti: ["scheda"], type: 'html', func: (coupon, parent?) => coupon.id_immagine ? `https://customer.klimaitalia.it/api/file/image/${coupon.id_immagine}`: ''}
    ],
    Headers: [
      CampoAggiuntivo.InputField("Codice", "prodotto", "text", "", {modificabile: false, printable:true}),
      CampoAggiuntivo.InputField("Descrizione", "descrizioneBreve", "text", "", {modificabile: false, printable:true}),
      {
        nome: "Scheda Prodotto", oggetti: ["scheda"], type: 'html', func: (coupon, parent: FieldViewerComponent) => ``,
        azioni:[
          {
            type:'func',
            icon: 'fas fa-download',
            tooltip:'Scarica la scheda prodotto',
            func:(coupon,CampoAggiuntivo, CampoPadre, Padre, apiPaths: ApiPathsService, component)=>{
              apiPaths.DownloadFileByUrl(`https://customer.klimaitalia.it/api/file/image/${Padre.id_scheda}`)
            }
          },
          {
            type:'func',
            icon: 'fas fa-eye',
            tooltip:'Visualizza la scheda prodotto',
            func:(coupon,CampoAggiuntivo, CampoPadre, Padre, apiPaths: ApiPathsService, component)=>{
              window.open(`https://customer.klimaitalia.it/api/file/image/${Padre.id_scheda}`, '_blank')
            }
          }
        ]
      },
      {
        nome: "Immagine Prodotto", oggetti: ["scheda"], type: 'html', func: (coupon, parent?) =>
          ``,
        azioni:[
          {
            type:'func',
            icon: 'fas fa-download',
            tooltip:'Scarica l\'immagine prodotto',
            func:(coupon,CampoAggiuntivo, CampoPadre, Padre, apiPaths: ApiPathsService, component)=>{
              apiPaths.DownloadFileByUrl(`https://customer.klimaitalia.it/api/file/image/${Padre.id_immagine}`)
            }
          },
          {
            type:'func',
            icon: 'fas fa-eye',
            tooltip:'Visualizza l\'immagine prodotto',
            func:(coupon,CampoAggiuntivo, CampoPadre, Padre, apiPaths: ApiPathsService, component)=>{
              window.open(`https://customer.klimaitalia.it/api/file/image/${Padre.id_immagine}`, '_blank')
            }
          }
        ]
      }
    ],
    MenuItems: [
      {
        path: "/sanpellegrino/shared/dynamiclist/catalogo-frigo",
        title: "Catalogo",
        icon: "fa-solid fa-qrcode",
        class: "",
        capacita: [],
        ruoliOperativi:["S", "DM", "NAM", "AG"]
      },
    ]
  }
  return OBJ;
}
